<template>
  <vk-modal :size="isFullScreen ? 'modal-full-screen' : ''" :show.sync="isOpen" :stuck="stuck">
    <vk-modal-title slot="header">{{title }}</vk-modal-title>
    <slot/>
    <div slot="footer" class="uk-text-right">
      <vk-button v-if="showCancelButton" class="uk-margin-small-right" @click.prevent="close">{{ cancelText }}</vk-button>
      <vk-button v-if="showOkButton" type="primary" @click.prevent="onConfirm">{{ confirmText }}</vk-button>
    </div>
  </vk-modal>
</template>

<script>
export default {
  name: "ModalDialog",
  props: {
    title: {
      type: String,
      default: '',
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
    stuck: {
      type: Boolean,
      default: false,
    },
    cancelText: {
      type: String,
      default: 'Cancel',
    },
    confirmText: {
      type: String,
      default: 'Ok',
    },
    customData: {
      type: Object,
      default: {},
    },
    showCancelButton: {
      type: Boolean,
      default: true,
    },
    showOkButton: {
      type: Boolean,
      default: true,
    },
    isFullScreen: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isOpen: false,
    }
  },
  watch: {
    show(newValue) {
      this.isOpen = newValue;
    },
  },
  mounted() {
    this.isOpen = this.show;
  },
  methods: {
    open() {
      console.log('opening');
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
      this.$emit('close', this.customData);
    },
    onConfirm() {
      this.$emit('confirm', this.customData);
      this.isOpen = false;
    },

    setData(obj) {
      this.customData = obj;
    }
  },
}
</script>

<style lang="scss">
  .uk-width-modal-full-screen {
    max-width: 1398px;
    width: 100%;
  }
</style>